// Makes each [data-row-href] table row navigate to that URL on click, while
// leaving nested links and buttons working on their own.
export function mountRowLinks(): void {
  document.querySelectorAll<HTMLElement>("[data-row-href]").forEach((row) => {
    const href = row.dataset.rowHref
    if (!href) return

    row.addEventListener("click", (event) => {
      // Let clicks on anything interactive behave normally.
      //
      // `dialog` matters as much as the rest: a modal opened from inside a row
      // — the workspace share dialog — is still a DOM descendant of it however
      // the top layer paints it, so without this, clicking its email field or
      // its backdrop would navigate the page out from under the modal.
      if (event.target instanceof Element &&
          event.target.closest("a, button, dialog, input, select, textarea, label")) {
        return
      }
      // Honor modifier clicks / middle-click as "open in new tab".
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) {
        window.open(href, "_blank")
        return
      }
      window.location.assign(href)
    })
  })
}

